import { render, staticRenderFns } from "./FormEmail.vue?vue&type=template&id=6a16bf92"
import script from "./FormEmail.vue?vue&type=script&lang=js"
export * from "./FormEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormEmail.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a16bf92')) {
      api.createRecord('6a16bf92', component.options)
    } else {
      api.reload('6a16bf92', component.options)
    }
    module.hot.accept("./FormEmail.vue?vue&type=template&id=6a16bf92", function () {
      api.rerender('6a16bf92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormEmail.vue"
export default component.exports